import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { CompanyAddressFormModel, DeviatingAddressFormModel, UserAddressFormModel } from '../types'

interface UseAddressFormHook {
  customerAddressForm: UserAddressFormModel
  companyAddressForm: CompanyAddressFormModel
  deviatingAddressForm: DeviatingAddressFormModel
}

/**
 * A custom hook to provide form objects for installation statement address form fields.
 * These objects include name and label.
 */
const useAddressForm = (): UseAddressFormHook => {
  const { t } = useCustomTranslation()

  const customerAddressForm: UserAddressFormModel = {
    addressAndHouseNumber: {
      name: 'customerAddress.addressAndHouseNumber',
      label: t('common.address-and-house-number'),
      required: true,
    },
    city: {
      name: 'customerAddress.city',
      label: t('common.city'),
      required: true,
    },
    country: {
      name: 'customerAddress.country',
      label: t('common.country'),
      required: true,
    },
    firstName: {
      name: 'customerAddress.firstName',
      label: t('common.firstName'),
      required: true,
    },
    lastName: {
      name: 'customerAddress.lastName',
      label: t('common.lastName'),
      required: true,
    },
    zipCode: {
      name: 'customerAddress.zipCode',
      label: t('common.zipCode'),
      required: true,
    },
  }

  const companyAddressForm: CompanyAddressFormModel = {
    addressAndHouseNumber: {
      name: 'companyAddress.addressAndHouseNumber',
      label: t('common.address-and-house-number'),
      required: true,
    },
    city: {
      name: 'companyAddress.city',
      label: t('common.city'),
      required: true,
    },
    country: {
      name: 'companyAddress.country',
      label: t('common.country'),
      required: true,
    },
    zipCode: {
      name: 'companyAddress.zipCode',
      label: t('common.zipCode'),
      required: true,
    },
    companyName: {
      name: 'companyAddress.companyName',
      label: t('common.company'),
      required: true,
    },
  }

  const deviatingAddressForm: DeviatingAddressFormModel = {
    addressAndHouseNumber: {
      name: 'deviatingAddress.addressAndHouseNumber',
      label: t('common.address-and-house-number'),
      required: true,
    },
    city: {
      name: 'deviatingAddress.city',
      label: t('common.city'),
      required: true,
    },
    country: {
      name: 'deviatingAddress.country',
      label: t('common.country'),
      required: true,
    },
    zipCode: {
      name: 'deviatingAddress.zipCode',
      label: t('common.zipCode'),
      required: true,
    },
  }

  return { customerAddressForm, companyAddressForm, deviatingAddressForm }
}

export default useAddressForm
